// src/pages/BridalPlanner/index.jsx
import React, { useEffect, useState } from "react";
import CollectionPage from "./Collectionpage";
import { getBridalPlanners, PRODUCTS_PER_PAGE } from "../data/bridalPlanners";

export default function BridalPlanner() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getBridalPlanners()
      .then(setProducts)
      .catch(err => setError(err.message || "Failed to load products"));
  }, []);

  if (error) {
    return <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>;
  }
  if (!products) {
    return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>;
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/bridal-planner",
    announcement: {
      headline: "Plan your perfect wedding in style!",
      subtext: "300+ designs to personalise • No code required",
    },
    hero: {
      title: "Bridal Planners",
      subtitle: "Every detail of your big day, beautifully organised",
     featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "This planner made wedding planning feel like a joy, not a chore. Absolutely beautiful.",
      quoteLink: "#",
      rating: "4.8",
      ratingCount: "500+",
    },
  };

  return <CollectionPage config={config} />;
}